















































import { isEmpty } from 'lodash-es';
import { defineComponent, ref, useContext, onMounted } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getIsBook } from '~/utils/solepro/products';
import { getFirstProLabel, getSecondProLabel, getLowestMetaPrice } from '~/utils/helpers/product';
import { productBuyCTATrack, productFreeCTATrack } from '~/helpers/trackings/24orepro/products';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import AddToWishlist from '~/components/AddToWishlist.vue';
import { Breadcrumb } from '~/modules/catalog/types';
import SfBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/SfBreadcrumbs.vue';
import ProductHeading from './ProductHeading.vue';
import ClientOnly from 'vue-client-only';
import { manageScroll } from '~/utils/helpers/functions';

export default defineComponent({
   props: {
      product: {
         type: Object as PropType<ProductForProductPageType>
      },
      breadcrumbs: {
         type: Array as PropType<Breadcrumb[]>
      }
   },
   components: {
      HTMLContent,
      AddToWishlist,
      ClientOnly,
      SfBreadcrumbs,
      ProductHeading
   },
   setup(props) {
      const { product } = props || {};
      const { app: { i18n }, $fc } = useContext();
      const freeLink = ref(product?.freeDemoURL ?? "");
      const firstLabel = ref<String>("");
      const secondLabel = ref<String>("");

      /**
       * @hot - Questo è solo per i non-libri, da testare poi con i libri se si rompe.
       * @todo: Occhio, qui manca la gestione delle demo, mancano ancora gli attributi.
       */


      const targetProduct = !isEmpty(product.additionalProducts) ?
         getLowestMetaPrice(product.additionalProducts) : product;

      const lowFrequencySpan = targetProduct.paymentFrequencies[0];

      /** 
       * Check if frequencySpan exist, instead, use simple price with currency converter.
      */
      onMounted(() => {
         const varLength = (Array.from(document.querySelectorAll('.solepro-option-card')).length > 1) || (!!product.variants && product.variants.length > 1); // @TODO fare il conteggio in maniera decente); // @TODO fare il conteggio in maniera decente
         if (lowFrequencySpan) {
            firstLabel.value = getFirstProLabel(targetProduct, lowFrequencySpan, i18n, $fc, null, varLength);
            secondLabel.value = getSecondProLabel(targetProduct, lowFrequencySpan, i18n, $fc, varLength);
         } else {
            firstLabel.value = `${$fc(targetProduct.price)}`;
         }
      })

      const trackProductFreeCTA = async () => await productFreeCTATrack(product);

      const hasOnlyBuyable = product.additionalProducts && product.additionalProducts.length > 0
         ? product.additionalProducts.every(p => p.buyable) : product.buyable;
      const hasSomeBuyable = product.additionalProducts && product.additionalProducts.length > 0
         && product.additionalProducts.some(p => p.buyable);

      return {
         firstLabel,
         secondLabel,
         trackProductFreeCTA,
         freeLink,
         isBook: getIsBook(product),
         hasOnlyBuyable,
         hasSomeBuyable,

      }

    },
    methods:{
      async manageScroll(evt){
         manageScroll(evt)
         const $t = this as any;
         await productBuyCTATrack($t.product);
      }
   },
})
